import { useMemo } from 'react';

import { Badge } from '@/components/ui/catalyst/badge';
import type { EntityChangeSchema } from '@/services/api/generated/entityChangesService';

import { CaseExpenseChangeCard } from './CaseExpenseChangeCard';
import { CHANGE_TYPE_ORDER } from './changeTypeConfig';

interface CaseExpenseChangeSectionProps {
  caseExpenses: EntityChangeSchema[];
}

export const CaseExpenseChangeSection: React.FC<CaseExpenseChangeSectionProps> = ({
  caseExpenses,
}) => {
  const sorted = useMemo(
    () =>
      [...caseExpenses].sort(
        (a, b) =>
          CHANGE_TYPE_ORDER[a.change_type] -
          CHANGE_TYPE_ORDER[b.change_type],
      ),
    [caseExpenses],
  );

  if (caseExpenses.length === 0) return null;

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <h3 className="text-base font-semibold text-gray-900">Case Expenses</h3>
        <Badge color="zinc" className="text-xs">
          {caseExpenses.length}
        </Badge>
      </div>
      <div className="space-y-2">
        {sorted.map((expense) => (
          <CaseExpenseChangeCard key={expense.id} entity={expense} />
        ))}
      </div>
    </div>
  );
};
